import maAccordion from '@/components/accordion'
import maInputSurface from '@/components/input/modules/text'
import maButtonWhite from '@/components/button-blue'
import maButton from '@/components/button-blue'
import maModal from '@/components/modal'
import maPhotoclaimGallery from '@/components/photoclaimGallery'
import maDamagedPart from './../damagedPart'
import maDamagedPartCamera from '../damagedPartCamera'
import { required, minValue } from 'vuelidate/lib/validators'
import maEventBus from '@/components/eventbus/index.js'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

const DAMAGE_BILLMA_AGENT_NEW = 'damage_billma_agent_new'
const E2E_NEW = 'e2e_new'

export default {
  mame: 'damagedPiece',
  mixins: [flowMixin, userFlowMixin],
  data() {
    return {
      inputSurfaceValue: this.damagedPiece.pieceSurface,
      inputTextNumberError: true,
      isVisibleOverallBtn: false,
      showModalButtons: false,
      collapsed: false
    }
  },

  validations: {
    inputSurfaceValue: {
      required,
      minValue: minValue(1)
    }
  },

  props: {
    damagedLiteral: {
      type: String,
      required: true
    },
    damagedKey: {
      type: String,
      required: true
    },
    damagedSurface: {
      type: [Number, String],
      required: true
    },
    damagedPiece: {
      type: Object,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true,
      default: false
    },
    photosTaken: {
      type: Boolean,
      default: false
    },
    overallPhoto: {
      type: Array,
      default: false
    },
    pieceRefIndex: {
      type: Number,
      required: true,
      default: 0
    }
  },

  computed: {
    isPhotoclaimFlow() {
      return this.isPhotoclaimUser
    },

    isMultidamageFlow() {
      return (
        this.flowName === DAMAGE_BILLMA_AGENT_NEW ||
        this.isPhotoclaimFlow ||
        E2E_NEW
      )
    },

    flowName() {
      return this.getUserFlow
    },

    surfaceInputIsValid() {
      return !this.$v.inputSurfaceValue.$error && this.inputSurfaceValue > 0
    },
    hasDamages() {
      return !!this.damagedPiece.damagedParts.find(
        (damagedPart) =>
          damagedPart.partDamages && damagedPart.partDamages.length > 0
      )
    },
    pieceTitle() {
      const partial = `${this.damagedLiteral} ${this.damagedPiece.pieceId}`
      const full = `${partial} - ${this.damagedPiece.pieceSurface} m2`

      return this.photosTaken ? full : partial
    },
    isDisabledBtn() {
      const hasPartDamages = this.damagedPiece.damagedParts.every(
        (damage) => 'partDamages' in damage
      )

      if (!hasPartDamages) {
        return true
      }
    }
  },

  components: {
    maAccordion,
    maInputSurface,
    maButtonWhite,
    maButton,
    maModal,
    maDamagedPart,
    maPhotoclaimGallery,
    maDamagedPartCamera
  },

  methods: {
    /**
     * Using the vulidate library, evaluates if there is an error in the inpus surface value and if so it will set the inputTextNumberError to true and scroll to the top of the page
     *
     */
    inputSurfaceValidation() {
      let validated = false
      this.$v.$touch()
      if (this.$v.inputSurfaceValue.$error) {
        maEventBus.$emit('inputTextNumbers:error')
        this.inputTextNumberError = true
        setTimeout(() => {
          this.inputTextNumberError = false
        }, 2000)
      } else {
        validated = true
      }
      return validated
    },

    handleOnPhotoclaimDamagesConfirmed(damagedPiece, damagedPart) {
      this.$emit('confirmPhotoclaimDamages', damagedPiece, damagedPart)
    },

    handleOnPhotoclaimDamagesEdit(
      damagedPiece,
      damagedKey,
      damagePart,
      damageIndex
    ) {
      this.$emit('edit:photoclaimDamage', {
        damagedPiece,
        damagedKey,
        damagePart,
        damageIndex
      })
    },

    handleOnPhotoclaimDamagesDelete(
      damagedPiece,
      damagedKey,
      damagePart,
      damageIndex
    ) {
      this.$emit('delete:photoclaimDamage', {
        damagedPiece,
        damagedKey,
        damagePart,
        damageIndex
      })
    },

    handleOnChangeSurfaceInput(value) {
      if (this.inputSurfaceValidation()) {
        this.$emit('surfaceChanged', value)
      } else {
        this.$emit('surfaceChanged', 0)
      }
    },

    deletePart(damagePart) {
      this.$emit('deletePart', damagePart)
    },
    handleOpenModal() {
      if (this.overallPhoto !== null) return

      this.$refs.modalOverallImage.showModal = true
    },

    handleOnShowModalOverallCamera() {
      this.$emit('openModalOverallCamera', this.damagedPart)
    },

    expandPiece() {
      this.$refs.accordion.showContent()
    },

    handleOverallImg() {
      this.$refs.modalOverallImage.showModal = false
      this.$refs.accordion.confirmPiece()
      this.$emit('overallStepConfirmed')
    },

    handleNoRequiredPhoto() {
      this.$refs.modalOverallImage.showModal = false
      this.$refs.accordion.confirmPiece()
      this.$emit('overallStepConfirmed')
    },

    showOtherButtons(newVal) {
      this.showModalButtons = true
    }
  },
  watch: {
    damagedSurface() {
      this.inputSurfaceValue = this.damagedSurface
    },
    overallPhoto(newVal) {
      this.showOtherButtons(newVal)
    }
  }
}
